// Purpose: preserve the existing geographic campaign and GMT+8 countdown contract.
// Integration: legacy filename is retained for the native loader. Shared markup
// adds the review as a separate slide; geo hide removes announcement blocks only.
// ==== Countdown Timer, usable for both static and dynamic banners ====
function parseDate(e){
  var n = Date.parse(e);
  if(!isNaN(n)) return n;
  return Date.parse(e.replace(/-/g,"/").replace(/[a-z]+/gi," "));
}
function getTimeRemaining(e){
  var n = parseDate(e) - Date.now(),
      d = Math.floor(n/864e5),
      h = Math.floor(n/36e5%24),
      m = Math.floor(n/6e4%60),
      s = Math.floor(n/1e3%60);
  return { total:n, days:d, hours:h, minutes:m, seconds:s };
}
function initializeClock(idOrElem, endtime){
  var t = typeof idOrElem === "string" ? document.getElementById(idOrElem) : idOrElem;
  if(!t) return;
  var s = t.querySelector(".days"),
      h = t.querySelector(".hours"),
      m = t.querySelector(".minutes"),
      sec = t.querySelector(".seconds"),
      dayWrap = t.querySelector(".c-day"),
      hourWrap = t.querySelector(".c-hour"),
      minWrap = t.querySelector(".c-min"),
      secWrap = t.querySelector(".c-sec"),
      wrapper = t.closest('.countdown-wrapper');

   // Purpose: one clock per element, including real editor section reloads.
  clearInterval(t.mvkCountdownInterval);
  var firstUpdate = true;

  function update(){
    if (!t.isConnected) { clearInterval(t.mvkCountdownInterval); return; }
    var e = getTimeRemaining(endtime);
    if (!Number.isFinite(e.total)) {
      if (wrapper) wrapper.style.display = 'none';
      clearInterval(t.mvkCountdownInterval); return;
    }
    if(s)   s.textContent = e.days;
    if(h)   h.textContent = ("0"+e.hours).slice(-2);
    if(m)   m.textContent = ("0"+e.minutes).slice(-2);
    if(sec) sec.textContent = ("0"+e.seconds).slice(-2);

    if(e.days <= 0 && dayWrap) dayWrap.style.display = "none";
    if(e.hours < 0 && hourWrap) hourWrap.style.display = "none";
    if(e.minutes < 0 && minWrap) minWrap.style.display = "none";
    if(e.seconds < 0 && secWrap) secWrap.style.display = "none";

    if (firstUpdate && wrapper) {
      wrapper.classList.remove('visually-hidden');
      wrapper.classList.add('ready');
      firstUpdate = false;
    }

    if(e.total <= 0){
      if(wrapper) wrapper.style.display = "none";
      t.style.display = "none";
      clearInterval(t.mvkCountdownInterval);
    }
  }
  update();
  // Expired/invalid deadlines must not start a hidden perpetual clock.
  if (getTimeRemaining(endtime).total > 0) t.mvkCountdownInterval = setInterval(update, 1000);
}

// ==== Geo Banners helpers ====
var geoBanners = [];
try {
  var geoDataTag = document.getElementById('geo-banners-data');
  if (geoDataTag) geoBanners = JSON.parse(geoDataTag.textContent);
} catch (e) { geoBanners = []; }

function getCookie(name) {
  var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
  if (match) return match[2];
}

var cookieExpireDays = 30;
function setCartCookie(a) {
  var date = new Date();
  date.setTime(date.getTime() + (cookieExpireDays * 86400000));
  var expires = '; expires=' + date.toGMTString();
  document.cookie = 'country-origin=' + a + expires + '; path=/';
}

function getVisitorCountry($callback) {
  var $country = getCookie("country-origin");
  if (!$country) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', 'https://devwebhooks.com/Maverick/geo/public/geoip.php?v=' + Math.floor(Math.random() * 1e9));
    xhr.onload = function () {
      if (xhr.status !== 200) return;
      var resp = {};
      try { resp = JSON.parse(xhr.responseText) || {}; } catch (e) {}

      var urlCurrency = (new URL(window.location.href).searchParams.get('currency') || '').toUpperCase();
      var country = resp.country_code || '';
      var geoCurrency = (resp.currency || '').toUpperCase();
      var detectedLang = resp.language || null;

      setCartCookie(country);
      // Existing first-visit detection saved the country but never delivered it
      // to the banner callback. Use the same detected code on this first view.
      if (typeof $callback === 'function') $callback({ country: country });

    };

    xhr.onerror = function () {};
    xhr.send();
  } else {
    if (typeof $callback === "function") $callback({ country: $country });
  }
}

// ==== Add Timer to Geo Banner slide ====
function addTimer(index, date, item) {
  var timer = document.createElement('div');
  timer.className = "countdown-wrapper";
  timer.innerHTML = `
    <div class="countdown">
      <div class="clock__piece c-day"><span class="days"></span><div class="smalltext">Day</div></div>
      <div class="clock__piece c-hour"><span class="hours"></span><div class="smalltext">Hour</div></div>
      <div class="clock__piece c-min"><span class="minutes"></span><div class="smalltext">Min</div></div>
      <div class="clock__piece c-sec"><span class="seconds"></span><div class="smalltext">Sec</div></div>
    </div>
  `;
  timer.id = "geo-countdown-" + index;
  item.querySelector('.announcement-text').after(timer);
  initializeClock(timer, date + ':00 GMT+0800');
}

// ==== Run section countdown if present ====
function initializeSectionClock() {
  var wrapper = document.getElementById("ctn-wrapper");
  if(wrapper) {
    var schedule = wrapper.getAttribute('data-schedule');
    if(schedule) initializeClock('countdown', schedule);
  }
 }

// Purpose: initialize the current header only, once per mount. Native Impulse
// owns Flickity; this lifecycle hook retains geo behavior after editor reloads.
function initializeGeoBanners() {
clearInterval(window.checkGeoTarget);
var mountedSlider = document.getElementById('AnnouncementSlider');
if (!mountedSlider || mountedSlider.dataset.mvkGeoReady === 'true') return;
try { geoBanners = JSON.parse(document.getElementById('geo-banners-data').textContent); }
catch (e) { geoBanners = []; }
window.checkGeoTarget = setInterval(function() {
  if (!mountedSlider.isConnected) { clearInterval(window.checkGeoTarget); return; }
  if (
    typeof getCookie === "function" &&
    typeof theme !== "undefined" &&
    typeof theme.announcementBar !== "undefined" &&
    document.querySelector('#AnnouncementSlider .flickity-slider') !== null
  ) {
    clearInterval(window.checkGeoTarget);
    getVisitorCountry(function(data) {
      if (!mountedSlider.isConnected || mountedSlider.dataset.mvkGeoReady === 'true') return;
      mountedSlider.dataset.mvkGeoReady = 'true';
      var countries = {
        "US": "United States", "GB": "United Kingdom", "TW": "Taiwan", "JA": "Japan", "HK": "Hong Kong",
        "SG": "Singapore", "CA": "Canada", "AU": "Australia", "DE": "Germany", "AE": "United Arab Emirates",
        "SA": "Saudi Arabia", "FR": "France", "CH": "Switzerland", "NL": "Netherlands", "IT": "Italy",
        "BE": "Belgium", "ES": "Spain", "MY": "Malaysia", "QA": "Qatar", "SW": "Sweden", "DK": "Denmark",
        "PH": "Philippines", "TR": "Türkiye", "TH": "Thailand", "AT": "Austria", "ID": "Indonesia",
        "IN": "India", "IE": "Ireland", "EG": "Egypt", "CN": "China", "KR": "South Korea", "NO": "Norway",
        "LK": "Sri Lanka", "VE": "Venezuela", "VN": "Vietnam", "IL": "Israel", "ME": "Mexico",
        "CY": "Cyprus", "GR": "Greece"
      };

      function createSliderItem($item) {
        var slider = document.createElement("div");
        slider.className = "announcement-slider__slide geo-target";
        // Metaobject phrases are JSON-decoded text, never executable HTML.
        var container = document.createElement('div');
        container.className = 'announcement-slider__slide-container';
        var text = document.createElement('span');
        text.className = 'announcement-text';
        text.textContent = $item.phrase || '';
        container.appendChild(text);
        slider.appendChild(container);
        return slider;
      }

      if (geoBanners.length > 0) {
        theme.announcementBar.unload();
        var $slider = document.querySelector('#AnnouncementSlider');
        geoBanners.forEach(function(banner, index) {
          if (banner.country === countries[data.country]) {
            if (banner.hide) {
              let check = mountedSlider.querySelectorAll('.announcement-slider__slide[id]');
              if (check.length > 0) { check.forEach(c => c.remove()) }
            }
            let item = createSliderItem(banner);
            $slider.appendChild(item);
            if (banner.timer) {
              let now = new Date();
              let targetDate = new Date(parseDate(banner.date + ':00 GMT+0800'));
              if (now.getTime() < targetDate.getTime()) {
                addTimer(index, banner.date, item);
              }
            }
          }
        });
        // Keep campaign priority while the review remains the final carousel item.
        var reviewSlide = $slider.querySelector('[data-mvk-review-slide]');
        if (reviewSlide) $slider.appendChild(reviewSlide);
        $slider.dataset.blockCount = $slider.children.length;
        theme.announcementBar.init();
      }
    });
  }
}, 10);
}
function initializeAnnouncementContent() {
  initializeSectionClock();
  initializeGeoBanners();
  document.querySelectorAll('.judge-me-totalcount').forEach(function(node) {
    var count = Number(node.textContent.replace(/,/g, ''));
    if (Number.isFinite(count)) node.textContent = count.toLocaleString('en-US');
  });
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializeAnnouncementContent, {once:true});
else initializeAnnouncementContent();
// Inline section scripts can execute again in the editor; keep one global hook.
if (!window.mvkAnnouncementLifecycleBound) {
  window.mvkAnnouncementLifecycleBound = true;
  document.addEventListener('shopify:section:load', function(event) {
    if (event.target.querySelector('#AnnouncementSlider')) initializeAnnouncementContent();
  });
}
